export default "__VITE_ASSET__aSyvPxEr__"